import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
let PaperHead = class PaperHead extends Vue {
    get disabledHandle() {
        // return this.paperInfo.participateCount > 0 || 1 == this.paperInfo.question_random
        return false;
    }
    created() {
    }
    handleSelectQues() {
        this.$emit("handle-select-ques");
    }
    systemSelectQues() {
        this.$emit("system-select-ques");
    }
};
tslib_1.__decorate([
    Prop({ type: Object, default: () => { } })
], PaperHead.prototype, "paperInfo", void 0);
tslib_1.__decorate([
    Prop({ type: Number, default: 0 })
], PaperHead.prototype, "questionCount", void 0);
tslib_1.__decorate([
    Prop({ type: Number, default: 0 })
], PaperHead.prototype, "paperScore", void 0);
PaperHead = tslib_1.__decorate([
    Component({
        name: 'PaperHead',
    })
], PaperHead);
export default PaperHead;
